import { createSelector } from 'reselect';

export const profileManagementSelector = (state) => state.profileManagement;

export const addresses = createSelector(
  [profileManagementSelector],
  (profile) => profile.addresses,
);
